/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Permissions_HintInputs */

const vi_api_keys_permissions_hint = /** @type {(inputs: Api_Keys_Permissions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoá chỉ gọi được các API đã chọn, và chỉ được đọc dữ liệu.`)
};

/**

* @param {Api_Keys_Permissions_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_permissions_hint = /** @type {((inputs?: Api_Keys_Permissions_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Permissions_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_permissions_hint(inputs)
});